export default __webpack_public_path__ + "static/media/health-document.142ab577.svg";